export default "__VITE_ASSET__Dzs7cDLz__"